import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";
import { toast } from "react-toastify";

export const userList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "user_List_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.alluserlist}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id }
      },
    );

    dispatch({ type: "user_List_success", payload: response.data });
    //console.log(response.data)

  } catch (error) {
    dispatch({
      type: "user_List_failure",
      payload: error.response.data,
    });
    toast.error(error.response.data.usr.message);
  }
};

export const deleteUser = (user_id) => async (dispatch) => {
  const { token, role_id } = getSession();

  dispatch({ type: "user_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updateUser}${user_id}`,
      {
        svc_active_yn: "N",
        sys_user_id: user_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "user_delete", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    console.log(error);
    dispatch({
      type: "user_delete_failure",
      payload: error.response.data,
    });
    toast.error(error.response.data.usr.message);
  }
};

export const createUser = (values) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_user_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.newUser}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_user_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_user_failure",
      payload: error.response.data.usr.message,
    });
    toast.error(error.response.data.usr.message);
  }
};

export const editUser = (values, userId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_user_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.userList}${userId}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_user_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_user_failure",
      payload: error.response.data,
    });
    // toast.error(error.response.data.usr.message);
  }
};

export const setCurrentUserData = (data) => (dispatch) => {
  dispatch({ type: "set_user_details", payload: data });
};

